@use "styles" as *;

.me-pill {
  display: inline-block;
  background: $me-pill-background;
  color: $me-pill-color;
  font-size: $font-size-xxs;
  width: $me-pill-size;
  height: $me-pill-size;
  line-height: $me-pill-size;
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  pointer-events: none;

  &--offset {
    position: absolute;
    inset: 0 0 auto auto;
    transform: translate(calc(50% / $phi), calc(-50% / $phi));
  }

  &--indicator {
    width: $me-pill-indicator-size;
    height: $me-pill-indicator-size;
    line-height: $me-pill-indicator-size;
    color: transparent;
  }
}
